export const environment = {
  production: false,
  enableEncoding: true,
  // apiBaseUrl: 'https://api-ubi.whatsloanfintech.com/v1/ekyc',

  // apiBaseUrl: 'https://api-ubi.whatsloanfintech.com/v1/ekyc', //vinayaks test build commented on 0742023 ec2 urls
  // nodeUrl: 'https://api-ubi.whatsloanfintech.com/v1',
  // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // irtcUrl: 'https://api-ubi.whatsloanfintech.com/v1',
  // webhookUrl: 'https://api-ubi.whatsloanfintech.com',
  // kccCustId: 'ubifintech',
  // cbsStatusFormat: 'send_to_cbs',
  // // kccNewUat: 'https://kccnewuat.unionbankofindia.bank.in',
  // kccNewUat:'https://api-ubi.whatsloanfintech.com',
  // serverType: 'UAT',

  // apiBaseUrl: 'http://localhost:8081/v1/ekyc', // localhost 
  // nodeUrl: 'http://localhost:8081/v1',
  // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // irtcUrl: 'http://localhost:8081/v1',
  // webhookUrl: 'http://localhost:8081',
  // kccCustId: 'ubifintech',
  // cbsStatusFormat: 'send_to_cbs',
  // kccNewUat: 'http://localhost:8081',
  // serverType: 'UAT',

  apiBaseUrl: 'https://mockserver.whatsloan.com/v1/ekyc', // localhost 
  nodeUrl: 'https://mockserver.whatsloan.com/v1',
  satSureBaseUrl: 'https://microservice.whatsloan.com',
  irtcUrl: 'https://mockserver.whatsloan.com/v1',
  webhookUrl: 'https://mockserver.whatsloan.com',
  kccCustId: 'ubifintech',
  cbsStatusFormat: 'send_to_cbs',
  kccNewUat: 'https://mockserver.whatsloan.com',
  serverType: 'UAT',
  kccNew_BRE_Checklist: "https://mockserver.whatsloan.com",

  // apiBaseUrl: 'http://3.7.233.228:8081/v1/ekyc', // localhost 
  // nodeUrl: 'http://3.7.233.228:8081/v1',
  // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // irtcUrl: 'http://3.7.233.228:8081/v1',
  // webhookUrl: 'http://3.7.233.228:8081',
  // kccCustId: 'ubifintech',
  // cbsStatusFormat: 'send_to_cbs',
  // kccNewUat: 'http://3.7.233.228:8081',
  // serverType: 'UAT',
  // kccNew_BRE_Checklist: "http://3.7.233.228:8081",

  //   apiBaseUrl: 'http://3.7.233.228:8100/v1/ekyc', // localhost 
  // nodeUrl: 'http://3.7.233.228:8100/v1',
  // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // irtcUrl: 'http://3.7.233.228:8100/v1',
  // webhookUrl: 'http://3.7.233.228:8100',
  // kccCustId: 'ubifintech',
  // cbsStatusFormat: 'send_to_cbs',
  // kccNewUat: 'http://3.7.233.228:8100',
  // serverType: 'UAT',
  // kccNew_BRE_Checklist: "http://3.7.233.228:8100",

  // apiBaseUrl: 'https://kccnewuat.unionbankofindia.bank.in/v1/ekyc', // uat 
  // nodeUrl: 'https://kccnewuat.unionbankofindia.bank.in/v1',
  // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // irtcUrl: 'https://kccnewuat.unionbankofindia.bank.in/v1',
  // webhookUrl: 'https://kccnewuat.unionbankofindia.bank.in',
  // kccCustId: 'ubifintech',
  // cbsStatusFormat: 'send_to_cbs',
  // kccNewUat: 'https://kccnewuat.unionbankofindia.bank.in',
  // serverType: 'UAT',


  // apiBaseUrl: 'http://3.7.233.228:8081/v1/ekyc', // local (direct)
  // nodeUrl: 'http://3.7.233.228:8081/v1',
  // irtcUrl: 'http://3.7.233.228:8081/v1',
  // webhookUrl: 'http://3.7.233.228:8081',
  // kccNewUat: 'http://3.7.233.228:8081',
  // kccNew_BRE_Checklist: "https://kccstp.unionbankofindia.bank.in",
  // apiBaseUrl: '/v1/ekyc', // proxied through localhost:4200
  // nodeUrl: '/v1',
  // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // irtcUrl: '/v1',
  // webhookUrl: '',
  // kccCustId: 'ubifintech',
  // cbsStatusFormat: 'send_to_cbs',
  // kccNewUat: '',
  // kccNew_BRE_Checklist: "https://kccuatapp.unionbankofindia.bank.in",
  // serverType: 'UAT',

  
  // apiBaseUrl: 'https://api-ubi.whatsloanfintech.com/v1/ekyc',  //ec2 urls for etb ntb dashboard testing
  // nodeUrl: 'https://api-ubi.whatsloanfintech.com/v1',
  // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // irtcUrl:'https://api-ubi.whatsloanfintech.com/v1',
  // webhookUrl:'https://api-ubi.whatsloanfintech.com',
  // kccCustId:"ubifintech",
  // cbsStatusFormat: 'send_to_cbs',
  // kccNewUat: "https://api-ubi.whatsloanfintech.com",
  // serverType: 'UAT',

  // apiBaseUrl: 'https://kccuatapp.unionbankofindia.bank.in/v1/ekyc', // ubi url uat 2406 && 15112022
  // nodeUrl: 'https://kccuatapp.unionbankofindia.bank.in/v1',
  // // satSureBaseUrl: 'https://microservice.whatsloan.com',
  // satSureBaseUrl: 'https://kccuatapp.unionbankofindia.bank.in',
  // irtcUrl: 'https://kccuatapp.unionbankofindia.bank.in/v1',
  // webhookUrl: 'https://kccuatapp.unionbankofindia.bank.in',
  // kccCustId: "ubikcc",
  // cbsStatusFormat: 'sent_to_cbs',
  // kccNewUat: "https://kccuatapp.unionbankofindia.bank.in",

  // irtcUrl:'https://microservice.whatsloan.com/v1',

  // apiBaseUrl: 'http://3.110.164.97:8081/v1/ekyc', //Shashi server 0205
  // nodeUrl: 'http://3.110.164.97:8081/v1',
  // satSureBaseUrl: 'http://3.110.164.97:8081',
  // irtcUrl:'http://43.204.163.6:8081/v1',
  // irtcUrl:'http://43.204.163.6:8081/v1',
  // irtcUrl:'https://api-ubi.whatsloanfintech.com/v1',

  // apiBaseUrl: 'http://13.232.59.97:8081/v1/ekyc', //For Vinayak to test
  // nodeUrl: 'http://13.232.59.97:8081/v1',

  // apiBaseUrl: 'http://172.30.163.182:8081/v1/ekyc', //Test server given by Shashi
  // nodeUrl: 'http://172.30.163.182:8081/v1',

  // nodeUrl: 'http://13.232.59.97:8081/v1',
  // apiBaseUrl: 'http://13.232.59.97:8081/v1/ekyc',
  //  nodeUrl: 'https://172.30.163.182/v1',
  // apiBaseUrl: 'https://172.30.163.182/v1/ekyc',
  // nodeUrl: 'http://localhost:8082/v1',
  imageUrl: '',
  rtcUrl: '',
  // rtcUrl: 'https://api-ubi.whatsloanfintech.com/rtc.html?file=https://api-ubi.whatsloanfintech.com',
  dsaBaseUrl: '',
  dsaEkycUrl: '',
  docUrl: 'http://localhost:8082',

  shareKey:"MKPzluxXq066hkatRNIFDc7CKJOBMdAi",
  someRandomString: {
    alpha: 'ghTTGIUhu8uy785t78Y796tb7y79HY9H79b587ec46wx69mu90N80V',
    beta: 'Th6gF9jAM1xo30neA02Hj6RSyut76UHKhiuYGUKHUiyi77TG7IGUI',
  },
  creditScoreSetting: {
    credScore: true,
    credCount: true,
    credMenu: 'ubi',
  },
  placeHolderSetting: {
    placeholder: 'Customer ID',
    demo: '',
    laasName: 'UBI LaaS',
  },
  urlSetting: {
    url: 'http://localhost:4200/',

  },
  disableInput: false,
};
